export default __webpack_public_path__ + "7ef5f501aa2d670399888b5bd9428b8e.png";